import { ComponentType } from 'react';
import { OrganizationsList } from './organizations-list';

export const Organizations: ComponentType = () => {
  return <OrganizationsList />;
};
